import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { renderRichText } from "../../utils/richTextUtils";

export default function Sidebar({
  title,
  description,
  details,
  relatedProjects,
  onNavigate,
  onLongNavigate,
  toggleSidebar,
  isSidebarOpen
}) {
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [isExitingToProject, setIsExitingToProject] = useState(false);

  useEffect(() => {
    const transitionClass = "transition-single-project-single-project";
    const appElement = document.querySelector(".App");
    const isLongTransition =
      appElement && appElement.classList.contains(transitionClass);
    const timeoutDuration = isLongTransition ? 1200 : 600;

    const timeOutDetails = setTimeout(() => {
      setIsDetailsOpen(true);
    }, timeoutDuration);

    return () => {
      clearTimeout(timeOutDetails);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isSidebarOpen) {
        const sidebarElement = document.querySelector(".sidebar");
        const projectSlider = document.querySelector(".project-slider");

        if (projectSlider && !sidebarElement.contains(e.target) && projectSlider.contains(e.target)) {
          toggleSidebar();
        }
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isSidebarOpen, toggleSidebar]);

  const handleLinkClick = (e, path) => {
    e.preventDefault();
    onNavigate(path);
  };

  const handleLinkLongClick = (e, path) => {
    e.preventDefault();
    onLongNavigate(path);
  };

  return (
    <>
      <button
        className={`mobile-menu-button ${isSidebarOpen ? "isOpen" : "isClosed"}`}
        onClick={toggleSidebar}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 612 612"
        >
          <g>
            <g>
              <g>
                <polygon points="612,286.893 325.116,286.893 325.116,0.296 286.903,0.296 286.903,286.893 0,286.893 0,325.107 286.903,325.107 286.903,611.704 325.116,611.704 325.116,325.107 612,325.107"></polygon>
              </g>
            </g>
          </g>
        </svg>
      </button>
      <section
        className={`sidebar ${isExitingToProject ? "isExitingProjects" : ""} ${isSidebarOpen ? "isOpen" : "isClosed"}`}
      >
        <div className="info">
          <h1 id="project-title" className={`opened`}>
            <Link
              to="/projects"
              id="titleLink"
              onClick={(e) => handleLinkClick(e, "/projects")}
            >
              {title}
            </Link>
          </h1>
          <div
            className={`description ${isDescriptionOpen ? "open" : ""}`}
          >
            <h3
              className="toggle-link"
              onClick={() => setIsDescriptionOpen(!isDescriptionOpen)}
            >
              Descriptif
            </h3>
            <div className="descriptif-content">
              {renderRichText(description)}
            </div>
          </div>
          <div className={`details ${isDetailsOpen ? "open" : ""}`}>
            <h3
              className="toggle-link"
              onClick={() => setIsDetailsOpen(!isDetailsOpen)}
            >
              Détails
            </h3>
            <div className="details-content">{renderRichText(details)}</div>
          </div>
        </div>
        {relatedProjects && relatedProjects.length > 0 && (
          <div className="related-projects">
            <h3>Autres projets</h3>
            <ul>
              {relatedProjects.map((relatedProject) => (
                <li key={relatedProject.id}>
                  <Link
                    to={`/projects/${relatedProject.slug}`}
                    className="related-link"
                    onClick={(e) =>
                      handleLinkLongClick(e, `/projects/${relatedProject.slug}`)
                    }
                  >
                    <p>{relatedProject.Title}</p>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>
    </>
  );
}
